import C from './Loading';

export default C;
